import { Button, Input, Switch } from "antd";
import { PlusIcon, SearchIcon } from "../../../../../atoms/CustomIcons";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../config/hooks";
import { removeServiceLineListing } from "../../ducks/actions";
// import PriorityIcon from "../../../../../atoms/CustomIcons/PriorityIcon";
import { PopUp } from "../../../../../atoms/PopUp";
import ServeLinePriorityPopup from "../ServeLinePriorityPopup";
import { useState } from "react";

interface FilterProps {
  setFilters: React.Dispatch<
    React.SetStateAction<{
      status: string;
    }>
  >;
  companyId: string | undefined;
  value: string;
  archived: boolean;
  showArchived: React.Dispatch<React.SetStateAction<boolean>>;
  setValue: React.Dispatch<React.SetStateAction<string>>;
}

export default function Filters(props: FilterProps) {
  const { setFilters, companyId, value, setValue, archived, showArchived } =
    props;

  const [isPriorityModalOpen, setIsPriorityModalOpen] = useState(false);
  const [loading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const onChange = (checked: boolean) => {
    dispatch(removeServiceLineListing());
    showArchived(checked);
    if (checked) {
      setFilters((prev) => ({
        ...prev,
        status: "archived",
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        status: "active",
      }));
    }
  };

  const PriorityPopup = {
    visibility: isPriorityModalOpen,
    content: (
      <ServeLinePriorityPopup
        title=""
        onClose={() => setIsPriorityModalOpen(false)}
        heading="Confirm deletion"
        paragraph={<>-----</>}
        btnText="Delete"
        loading={loading}
        btnApi={() => null}
      />
    ),
    width: 740,
    onCancel: () => setIsPriorityModalOpen(false),
  };

  return (
    <div className="filtersWrapper">
      <div className="filtersTop">
        <div className="filterSearch">
          <Input
            prefix={<SearchIcon />}
            placeholder="Search"
            allowClear
            value={value}
            onChange={(e) => setValue(e?.target?.value?.toLowerCase())}
          />
        </div>
        <div className="right_service_filter">
          <div className="filterToggle">
            <div className="filterBox">
              <div className="switchBox">
                <Switch onChange={onChange} checked={archived} />
                Show archived
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {/* <div className="serviceLinePriority">
              <Button
                icon={<PriorityIcon />}
                htmlType="button"
                className="outlined-btn"
                onClick={() => setIsPriorityModalOpen(true)}
                style={{ height: "37px" }}
              >
                Service line priority
              </Button>
            </div> */}
            <div className="filterDownload">
              <Button
                icon={<PlusIcon />}
                type="primary"
                onClick={() =>
                  navigate(`/company-settings/create-service-line/${companyId}`)
                }
              >
                Create service line
              </Button>
            </div>
          </div>
        </div>
      </div>

      <PopUp {...PriorityPopup} />
    </div>
  );
}
